export enum GameStateType {
  FullBear,
  FullCriminal,
  InPlay,
  Initial,
}
